<template>
  <div 
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;" 
    class="Kanit mx-auto bg-home">
    <!-- Header -->
    <!-- <Header :isHeaderFixed="false"></Header> -->

    <!-- Content Box -->
    <div class="wrapper-content-box py-4" style="height: 100%"> 
      <div class="content-box d-flex flex-column align-center justify-center" style="height: 100%; position: relative;">
        <div v-if="!loading" style="width: 100%;">
          <template v-if="!isRenewSuccess">
            <p class="primary--text mb-6" style="font-size: 24px; font-weight: 700;">อายุสมาชิกของท่านได้หมดลงแล้ว</p>
            <p style="font-size: 24px; color: #999;">กรุณาลงทะเบียนเพื่อต่อสมาชิก</p>

            <!-- Button -->
            <div style="
              position: absolute;
              width: 100%;
              left: 0;
              padding: 0 16px;
              bottom: 4px;
            ">
              <v-row>
                <v-col cols="5">
                  <v-btn
                    tile
                    dark
                    color="#000"
                    @click="changePage('home')"
                    style="width: 100%; height: 48px;"
                  >
                    ย้อนกลับ
                  </v-btn>
                </v-col>
                <v-col cols="7">
                  <v-btn
                    tile
                    dark
                    color="#000"
                    style="width: 100%;  height: 48px;"
                    @click="renewMember"
                  >
                    ลงทะเบียนสมาชิก
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-else>
            <div class="text-center" style="width: 100%;">
              <v-avatar size="62" color="#898989">
                <v-icon dark x-large>
                  mdi-check
                </v-icon>
              </v-avatar>
              <div style="font-size: 18px;" class="pt-6">ลงทะเบียนต่ออายุสมาชิกเรียบร้อยแล้ว</div>
            </div>
            <div
              style="
                position: absolute;
                width: 100%;
                left: 0;
                padding: 0 16px;
                bottom: 16px;
              "
            >
              <v-btn
                tile
                dark
                color="#000"
                @click="changePage('profile')"
                style="width: 100%; height: 48px; font-size: 18px;"
              >
                ตกลง
              </v-btn>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";

export default {
  data() {
    return {
      isRenewSuccess : false,
      loading: false
    }
  },
  components: {
    Header
  },  
  methods: {
    renewMember() {
      var data = {
        member_id: this.$store.state.member.id
      };
      this.loading = true;
      axios
        .post(this.serverUrl + "lamy/renew", data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            this.loading = false;
            this.isRenewSuccess = true;
          } else {
            await this.$swal.fire({
              text: response.data.reason,
              confirmButtonColor: '#000'
            });
          }
          
        });
    },
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>